module.exports = __webpack_public_path__ + "static/microsoft_azure-5055ef625509ea1d996247f1b52a8e0b.png";